import React from 'react';
import { Fab, Zoom } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { useBranding } from '../../contexts/BrandingContext';

export default function CopilotLauncher({ onOpen }: { onOpen: () => void }) {
  const branding = useBranding();
  const enabled = !!branding.features?.enableCopilot; // default disabled unless explicitly enabled
  if (!enabled) return null;
  return (
    <Zoom in>
      <Fab color="primary" onClick={onOpen} sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1500 }} aria-label="Open Copilot">
        <SmartToyIcon />
      </Fab>
    </Zoom>
  );
}

